import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';


@Injectable({providedIn: 'root'})
export class AuthService {

  constructor () {}

  jwtHelper = new JwtHelperService();

  public getToken(): string {
    return localStorage.getItem('token');
  }

  public isAuthenticated(): boolean {

    const token = this.getToken();

    return !this.jwtHelper.isTokenExpired(token);
  }

}
